// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import cardWidget from './js/widgets/cardWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import * as socialNetworkWidget from './js/widgets/socialNetworkWidget.js';
// Custom Theme Scripts
import './js/localjs.js';
import './js/parallax.min.js';
import AOS from 'aos';
import 'aos/dist/aos.css';


// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();
     cardWidget();  
    seoWidget(); 
    cssSponsors();
  });
  AOS.init({
    duration: 1000, // Duration of the animation
    easing: 'ease-in', // Easing function (e.g., 'ease', 'linear', 'ease-in-out')
    
  });
}
if (window.location.pathname === '/') {
  $(window).on('load', function() {
    videoWidget();
    socialNetworkWidget.facebookfeed(true);
    socialNetworkWidget.instafeed(true);   
});
}
